var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15904_24424)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6114 6.70364C13.6114 8.7491 11.9532 10.4073 9.90772 10.4073C7.86226 10.4073 6.20408 8.7491 6.20408 6.70364C6.20408 4.65817 7.86226 3 9.90772 3C11.9532 3 13.6114 4.65817 13.6114 6.70364ZM12.2225 6.70364C12.2225 7.98205 11.1861 9.01841 9.90772 9.01841C8.62931 9.01841 7.59295 7.98205 7.59295 6.70364C7.59295 5.42522 8.62931 4.38886 9.90772 4.38886C11.1861 4.38886 12.2225 5.42522 12.2225 6.70364ZM6.20364 11.3332C4.15817 11.3332 2.5 12.9914 2.5 15.0368V16.8886L17.5 16.8888V15.037C17.5 12.9915 15.8418 11.3333 13.7964 11.3333L6.20364 11.3332ZM13.3334 12.7222C14.8675 12.7222 16.1111 13.9658 16.1111 15.4999L3.88886 15.4998C3.88886 13.9657 5.13249 12.722 6.66659 12.722L13.3334 12.7222Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15904_24424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPeople);
export default __webpack_public_path__ + "static/media/icn_people.0558bf5fdfdb1a6211fb924f07821060.svg";
export { ForwardRef as ReactComponent };